import EmptyState from "@/components/empty-state";
import { useTranslations } from "@/lib/static-intl";

const EMPTY_TEXT = {
  no_content: "No relevant content was found. Please try another word.",
  no_reels_content: "No relevant content was found.",
  No_user: "No user was found. Please try another word.",
  profile_empty: "Nothing saved or posted yet.",
};

// Fitting muted line icon per empty context.
const EMPTY_ICON = {
  no_content: "lucide:search",
  no_reels_content: "lucide:search",
  No_user: "lucide:user-round-search",
  profile_empty: "lucide:bookmark",
};

const NoNotesAvailable = ({ text = "no_content" }) => {
  const t = useTranslations("creator_service.creator_note_manager");
  const message = t.has(text) ? t(text) : EMPTY_TEXT[text] || text;

  return (
    <div className="w-full h-[50vh] flex items-center justify-center">
      <EmptyState icon={EMPTY_ICON[text] || "lucide:search"} title={message} />
    </div>
  );
};

export default NoNotesAvailable;
